export default {
    ordersLayout: {
        back: "Înapoi",
        emptyOrders: "Nu ai încă nicio comandă.",
        loading: "Se încarcă",
        storeLabel: "Magazin",
        totalLabel: "Total",
        storeAddressPending: "Adresa va fi disponibilă în curând",
        productNameFallback: "Produs",
        ecListTitle: "Comenzile tale",
        ecStatusInStore: "Stare: achiziție în magazin",
        ecOrderNumber: "Număr comandă: {{order_number}}",
        ecDateStore: "{{date}} · {{store_name}}",
        ecCountTotalOne: "{{count}} buc.: total {{amount}}",
        ecCountTotalOther: "{{count}} buc.: total {{amount}}",
        ecViewOrder: "Vezi comanda >",
        ecViewOrderA11y: "Vezi comanda {{order_number}}",
        ecBackToOrders: "Înapoi la comenzile tale",
        ecInStoreDate: "Achiziție în magazin – {{date}}",
        ecProductsOne: "Produs",
        ecProductsOther: "Produse",
        ecSku: "Ref. {{sku}}",
        ecQty: "Cantitate: {{qty}}",
        ecWarrantyExpired: "În afara garanției",
        ecWarrantyActive: "În garanție",
        ecSubtotalOne: "Subtotal – {{count}} buc.",
        ecSubtotalOther: "Subtotal – {{count}} buc.",
    }
}



// WEBPACK FOOTER //
// ./src/locales/ro/index.js